export default __webpack_public_path__ + "assets/5be09e73d817f931801d9c009f371663.mp4";